// Services
import treatmentService from '@/app/services/main/treatment/treatment-service.js';

// Third party libraries
import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

export default {
	name: 'ModalAddTreatment',
	components: {
		DatePicker
	},
	mixins: [
		toastMessageMixins,
		dateMixins
	],
	props: {
		isAddModalLoading: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return this.initializeModalData();
	},
	computed: {
		validationRules() {
			let fields = {
				selectedBrand: {},
				treatmentDetails: {
					selectedBundleId: {},
					treatmentDate: {}
				}
			}

			fields.treatmentDetails = vuelidateUtil.setFieldsRequired(fields.treatmentDetails, true);
			fields.treatmentDetails = vuelidateUtil.setIsFutureNextYear(fields.treatmentDetails, 'treatmentDate');
			fields = vuelidateUtil.setRequiredValidation(fields, 'selectedBrand');

			return fields;
		}
	},
	watch: {
		selectedBrand(newBrand) {
			// clear any data it has when product List is refreshed
			this.treatmentDetails.selectedBundleId = '';
			this.productList = [];

			if (newBrand) {
				this.getProductList();
			}
		},
		isAddModalLoading(isLoading) {
			if (!isLoading) {
				this.closeModal();
			}
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		initializeModalData() {
			return {
				treatmentDetails: {
					selectedBundleId: '',
					treatmentDate: ''
				},
				selectedBrand: '',
				brandList: [],
				productList: [],
				isBrandsLoading: false,
				isProductLoading: false
			}
		},
		getBrandsList() {
			this.isBrandsLoading = true;
			const queryParams = {
				productTypeName: 'treatment',
				treatment: true	
			};

			treatmentService.getBrands(queryParams)
				.then(res => {
					this.isBrandsLoading = false;
					if (res.status === STATUS_CODES.SUCCESS) {
						this.brandList = res.data.data;
					} else {
						const { ERROR_GET_BRAND_LIST } = this.toastMessages.brand();
						this.showAPIErrorToast(ERROR_GET_BRAND_LIST, res);
					}
				});
		},
		getProductList() {
			this.isProductLoading = true;

			let bundleOptions = {
				'f_isCustomBundle': false,
				'f_treatment': true,
				'f_brandId': this.selectedBrand,
				'limit': 100
			}

			treatmentService.getBundles(bundleOptions)
				.then(res => {
					this.isProductLoading = false;
					if (res.status === STATUS_CODES.SUCCESS) {
						this.productList = res.data.data;
					} else {
						const { ERROR_GET_PRODUCT_LIST } = this.toastMessages.product();
						this.showAPIErrorToast(ERROR_GET_PRODUCT_LIST, res);
					}
				});
		},
		show() {
			this.clearModalFields();
			$(this.$refs.modalAddTreatment).modal('show');
			this.getBrandsList();
		},
		closeModal() {
			$(this.$refs.modalAddTreatment).modal('hide');
		},
		clearModalFields() {
			Object.assign(this.$data, this.initializeModalData());
			this.$v.$reset();
		},
		addTreatment() {
			if (this.$v.$invalid || this.isAddModalLoading) {
				return;
			}

			const treatmentDetails = {
				selectedBundleId: this.treatmentDetails.selectedBundleId,
				treatmentDate: this.dateToISO(this.treatmentDetails.treatmentDate)
			};
			
			this.$emit('addTreatment', treatmentDetails);
		},
		onBlur(field) {
			const { selectedBrand, treatmentDetails } = this.$v;
			if (field === 'brand') {
				selectedBrand.$touch();
			} else if (field === 'product' && selectedBrand) {
				treatmentDetails.selectedBundleId.$touch();
			}
		}
	},
	validations() {
		return this.validationRules;
	}
} 